import { render, staticRenderFns } from "./corpIcon.vue?vue&type=template&id=4e9e5117&"
import script from "./corpIcon.vue?vue&type=script&lang=js&"
export * from "./corpIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e9e5117')) {
      api.createRecord('4e9e5117', component.options)
    } else {
      api.reload('4e9e5117', component.options)
    }
    module.hot.accept("./corpIcon.vue?vue&type=template&id=4e9e5117&", function () {
      api.rerender('4e9e5117', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ui/corpIcon.vue"
export default component.exports